import { useController } from 'react-hook-form';
import type { VisibilityState, OnChangeFn, Updater } from '@tanstack/react-table';
import { useCallback } from 'react';

export const useVisibilityState = (): [VisibilityState, OnChangeFn<VisibilityState>] => {
  const { field } = useController({ name: 'visibility', defaultValue: {} });

  const onVisibilityChange: OnChangeFn<VisibilityState> = useCallback(
    (updaterOrValue: Updater<VisibilityState>) => {
      const nextState = typeof updaterOrValue === 'function' ? updaterOrValue(field.value) : updaterOrValue;

      field.onChange(nextState);
    },
    [field],
  );

  return [field.value, onVisibilityChange];
};
